import { useQuery } from "@tanstack/react-query";
import { api, BACKEND } from "@/lib/api";

export const useThemes = () =>
  useQuery({ queryKey: ["inspiration"], queryFn: () => api.get("/inspiration").then((r) => r.data) });

export const imgUrl = (url) => (url?.startsWith("/api") ? `${BACKEND}${url}` : url);

export const coverImgStyle = (c) => ({
  objectPosition: `${c.x * 100}% ${c.y * 100}%`,
  transform: `scale(${c.zoom || 1})`,
  transformOrigin: `${c.x * 100}% ${c.y * 100}%`,
});

export const pickSurprise = (slugs, currentFirst) => {
  const key = (a) => [...a].sort().join(",");
  const cur = key(currentFirst);
  for (let tries = 0; tries < 20; tries++) {
    const pick = [...slugs].sort(() => Math.random() - 0.5).slice(0, 4);
    if (key(pick) !== cur) return pick;
  }
  return slugs.slice(0, 4);
};
